import { i18nFilter } from "app/filters/i18nFilter";
import { SingleMetricContainerTemplateV2 } from "../dashboard/singleMetric/SingleMetricContainerTemplate-v2";
import UniqueVisitorsDataFetcherFactory from "../widget-fetchers/UniqueVisitorsFetcherFactory";
import { SingleMetricWidget } from "./SingleMetricWidget";

export const unsupportedDateKeys = {
    Desktop: "metric.uniquevisitors.unsupporteddate.date",
    MobileWeb: "metric.uniquevisitors.unsupporteddate.date.mobileweb",
    Total: "metric.uniquevisitors.unsupporteddate.date.mobileweb",
};
export class UniqueVisitorsWidget extends SingleMetricWidget {
    static getWidgetMetadataType() {
        return "UniqueVisitors";
    }

    static getWidgetResourceType() {
        return "SingleMetric";
    }

    public unsupportedDateKey;

    constructor() {
        super();
    }

    initWidget(widgetConfig, context) {
        super.initWidget(widgetConfig, context);
    }

    public unsupportedDate() {
        return this._widgetConfig.properties.options.unsupportedDuration;
    }

    public claimMissing() {
        return this._widgetConfig.properties.options.claimMissing;
    }

    public getUnsupportedDateKey() {
        return i18nFilter()(unsupportedDateKeys[this._params.webSource]);
    }

    protected getDataFetcherFactory() {
        return UniqueVisitorsDataFetcherFactory;
    }

    protected noWindow() {
        return this._widgetConfig.properties.options.noWindow;
    }

    // user regular single metric component template
    get templateUrl() {
        return `/app/components/widget/widget-templates/singlemetric.html`;
    }
    get templateComponent() {
        return SingleMetricContainerTemplateV2;
    }
    public canAddToDashboard() {
        return false;
    }

    public getWidgetModel() {
        const model = super.getWidgetModel();
        model.metric = "UniqueUsers";
        return model;
    }
}

UniqueVisitorsWidget.register();
